import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/ContactStyles.css";

const Contact = () => {
  const imagePath = `${process.env.PUBLIC_URL}/images/userImages`;
  const iconPath = `${process.env.PUBLIC_URL}/images/icons`;

  return (
    <div className="contact-page">
      {/* Contenedor del Navbar */}
      <div className="navbar-placeholder"></div>

      {/* Sección 1: Ponte en Contacto */}
      <section
        className="contact-section"
        style={{
          backgroundImage: `url(${imagePath}/contac.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay"></div>
        <div className="container text-left">
          <h1 className="contact-title">¡Ponte en Contacto!</h1>
          <p className="contact-subtitle">
            Estamos aquí para ayudarte. Explora nuestras opciones de contacto y obtén
            una respuesta rápida y personalizada.
          </p>
        </div>
      </section>

      {/* Sección 2: ¿Cómo Contactarnos? */}
      <section className="how-to-contact-section">
        <div className="container">
          <h2 className="how-to-title">¿Cómo Contactarnos?</h2>
          <div className="steps-row">
            {[1, 2, 3, 4, 5, 6].map((step) => (
              <div key={step} className="step-card">
                <div className="step-icon-container">
                  <img
                    src={`${iconPath}/step${step}.png`}
                    alt={`Paso ${step}`}
                    className="step-icon"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                </div>
                <h3 className="step-title">Paso {step}</h3>
                <p className="step-description">
                  {step === 1
                    ? "Selecciona el proyecto de tu interés"
                    : step === 2
                    ? "Completa el formulario de contacto"
                    : step === 3
                    ? "Habla con un asesor especializado"
                    : step === 4
                    ? "Gestiona tu crédito con nuestra ayuda"
                    : step === 5
                    ? "Firma tus documentos digitalmente"
                    : "Realiza el pago inicial sin complicaciones"}
                </p>
              </div>
            ))}
          </div>
        </div>
        <hr className="custom-divider" />
      </section>

      {/* Sección 3: Información de Contacto */}
      <section
        className="contact-info-section"
        style={{
          backgroundImage: `url(${imagePath}/footC.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay"></div>
        <div className="container d-flex align-items-start">
          {/* Mensaje a la izquierda */}
          <div className="contact-message">
            <h2 className="info-title">Estamos para ayudarte</h2>
            <p className="info-message">
              Resuelve tus dudas o consulta cualquier información. ¡Estamos aquí para ti!
            </p>
          </div>

          {/* Cuadros de opciones a la derecha */}
          <div className="info-row">
            <div className="info-card">
              <div
                className="info-icon"
                style={{
                  backgroundImage: `url(${iconPath}/telefono.png)`,
                  filter: "brightness(0) invert(1)",
                }}
              ></div>
              <h4 className="info-label">Teléfono</h4>
              <p className="info-text">+57 123 456 7890</p>
            </div>

            <div className="info-card">
              <div
                className="info-icon"
                style={{
                  backgroundImage: `url(${iconPath}/correo.png)`,
                  filter: "brightness(0) invert(1)",
                }}
              ></div>
              <h4 className="info-label">Correo</h4>
              <p className="info-text">conto@const.com</p>
            </div>

            <div className="info-card">
              <div
                className="info-icon"
                style={{
                  backgroundImage: `url(${iconPath}/direccion.png)`,
                  filter: "brightness(0) invert(1)",
                }}
              ></div>
              <h4 className="info-label">Dirección</h4>
              <p className="info-text">Calle 123 #45-67, Bogotá, Colombia</p>
            </div>

            <div className="info-card">
              <div
                className="info-icon"
                style={{
                  backgroundImage: `url(${iconPath}/horario.png)`,
                  filter: "brightness(0) invert(1)",
                }}
              ></div>
              <h4 className="info-label">Horario</h4>
              <p className="info-text">Lunes a Viernes: 8am - 5pm</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
